export {default as FirstWeek} from './FirstWeek.connect';
